import _ from 'lodash';

import { PRICE_SELECTED, QUOTED, START } from 'pu-data/QuoteSteps';
import defaultParameters from './defaultParameters';
import defaultQuote from './defaultQuote';

// Initial state for the store, including data when returning from cart
const state = {
  loading: false,
  parameters: defaultParameters,
  parametersChanged: false,
  boardConfirmSpecs: false,
  quoteStep: START,
  lineItemId: null,
  destroy: false,
};

if (Spree.quote) {
  state.quote = Spree.quote;
} else {
  state.quote = defaultQuote;
}

if (Spree.quote_parameters) {
  state.parameters = _.assign(defaultParameters, Spree.quote_parameters);

  if (Spree.quote_parameters.supplier_selected) {
    state.quoteStep = PRICE_SELECTED;
  } else {
    state.quoteStep = QUOTED;
  }
}

export default state;